import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, FormGroup } from 'react-bootstrap';
import TagCloud from '../TagCloud/TagCloud';
import { classNames } from '../../utils/v4/utils';

export default class AddLocationDialog extends Component {
  getInitialState() {
    return {
      name: '',
      description: '',
      tags: [],
      error: null,
      showError: false,
    };
  }

  state = this.getInitialState();

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { show } = nextProps;

    if (!show) {
      this.setState(this.getInitialState());
    }
  }

  onChange = event => {
    const { showError } = this.state;
    const { name, value } = event.target;

    if (name === 'name' && (value.includes('*') || value.includes('/'))) {
      return;
    }

    this.setState({ [name]: value }, () => {
      if (showError) {
        this.validate();
      }
    });
  };

  onChangeTags = tags => this.setState({ tags });

  add = () => {
    const { onSuccess } = this.props;
    const { name, description, tags } = this.state;

    if (this.validate()) {
      onSuccess({ name, description, tags });
    }
  };

  errorClass = error => (error ? 'error' : null);

  validate = () => {
    const { name } = this.state;
    let error = null;

    if (!name.trim()) {
      error = 'This field cannot be empty.';
    } else if (!this.isUniqueSiblingName(name)) {
      error = 'This is already in use.';
    }

    this.setState({ showError: true, error });

    return !error;
  };

  isUniqueSiblingName = name => {
    const { locations, parent } = this.props;
    const siblings = locations.filter(item => item.parent === parent);

    return !siblings.some(item => item.name.toLowerCase().trim() === name.toLowerCase().trim());
  };

  render() {
    const { type = 'location', show, onHide } = this.props;
    const { name, description, tags, error } = this.state;
    const capitalisedType = type.charAt(0).toUpperCase() + type.slice(1);

    return (
      <Modal
        dialogClassName="location-dialog"
        bsSize="lg"
        backdrop="static"
        show={show}
        onHide={onHide}
      >
        <Modal.Header>
          <Modal.Title data-test="modal-addlocation-title">Add {capitalisedType}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {this.errorClass(error) && (
              <span className="text-sunrise font-bold  mt-1 mb-4">{error}</span>
            )}
            <div className={classNames('relative group', this.errorClass(error) ? 'mt-2' : '')}>
              <label
                htmlFor="user-input-name"
                className=" form-label text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 absolute -top-2 left-6 bg-white px-2 transition-all group-focus-within:text-warmth"
              >
                Name <span className="text-red-500">*</span>
              </label>
              <input
                data-test="modal-addlocation-input-name"
                id="user-input-name"
                type="text"
                name="name"
                placeholder="Enter a name"
                value={name}
                onChange={this.onChange}
                autoFocus
                className="w-full text-xl  px-2 py-3 rounded-2xl border border-gray-200 focus:border-warmth focus:ring-0 transition-all outline-none"
              />
            </div>
          </div>

          <div className="relative group mt-4">
            <label
              htmlFor="create-folder-description"
              className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 absolute -top-2 left-6 bg-white px-2 transition-all group-focus-within:text-warmth"
            >
              Description
            </label>
            <textarea
              id="create-folder-description"
              data-test="modal-addlocation-input-desc"
              rows="1"
              onInput={e => {
                e.target.style.height = 'auto';
                e.target.style.height = `${e.target.scrollHeight}px`;
              }}
              value={description}
              onChange={this.onChange}
              name="description"
              placeholder="Enter description"
              className="w-full text-xl font-medium px-2 py-3 rounded-2xl border border-gray-200 focus:border-warmth focus:ring-0 transition-all outline-none resize-none"
            />
          </div>

          <FormGroup>
            <TagCloud tags={tags} onChange={this.onChangeTags} />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={onHide}>
            Cancel
          </Button>
          <Button
            data-test="modal-addlocation-button-add"
            className="btn-add"
            bsStyle="primary"
            onClick={this.add}
          >
            Add {capitalisedType}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

AddLocationDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  type: PropTypes.string,
  locations: PropTypes.array,
  parent: PropTypes.string,
};
